// © Sitecore Corporation A/S. All rights reserved. Sitecore® is a registered trademark of Sitecore Corporation A/S.
/**
 * Checks if the cookie exists in the cookie string
 * @param cookieStr - The cookie string containing every cookie
 * @param cookieName - The cookie name to be found
 * @returns - boolean value, if the cookie is found in the cookie string
 */
export function cookieExists(cookieStr, cookieName) {
    return cookieStr.split('; ').some((cookie) => cookie.split('=')[0] === cookieName);
}
